/**
 * Extracts the base URL of a WebObjects application.
 *
 * @param {string} urlString - The URL from which to extract the base URL.
 * @returns {string | null} The base URL for the WebObjects application, or null if the URL is invalid.
 *
 * If the hostname of the URL is 'localhost' or '127.0.0.1', the function assumes the application is running in development mode and returns the localhost URL for the WebObjects application.
 * Otherwise, it extracts the subdomain from the URL's hostname and uses it to construct the URL for the WebObjects application.
 */
export function getWebObjectsAppUrl(urlString: string): string | null {
  const url = new URL(urlString);

  if (url.hostname === "localhost" || url.hostname === "127.0.0.1") {
    // The application is running in the development mode
    return `${url.origin}/cgi-bin/WebObjects/doit-wo-app.woa`;
  }

  const urlParts = url.hostname.split(".");

  return `${url.origin}/cgi-bin/WebObjects/${urlParts[0]}.woa`;
}
